import component from './SingleItemLayoutConstructor.vue'
export default component
